import IFormModel from "@/models/IFormModel";
import TranslatedValueCreate from "@/models/translated-value/TranslatedValueCreate";
import ShipmentTypeRules from "@/models/shipment-type/ShipmentTypeRules";
import {ValidationRule} from "@/declarations/ValidationRule";
import {DeliveryMethod} from "@/helpers/constants";
import {IPostageBulkPriceCreate} from "@/models/shipment-type/PostageBulkPriceAdminModels";

export default class ShipmentTypeCreate implements IFormModel {

	public name: TranslatedValueCreate = new TranslatedValueCreate();
	public postageBulkPrices: IPostageBulkPriceCreate[] = [];
	public externalId: string | null = null;
	public isBulkyGoodsCharged: boolean = false;
	public deliveryMethod: DeliveryMethod | null = null;

	public reset(): void {
		this.name = new TranslatedValueCreate();
		this.postageBulkPrices = [];
		this.externalId = null;
		this.isBulkyGoodsCharged = false;
		this.deliveryMethod = null;
	}

	public rules(property: string): ValidationRule[] {
		switch(property) {
			case 'deliveryMethod':
				return ShipmentTypeRules.deliveryMethod;
			default:
				return [];
		}
	}

}
